import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TreeNode } from 'primeng/primeng';
import { InstituteDepartamentModel } from '../../shared/model/institute-departaments.model';
import { InstituteDepartamentService } from '../../shared/service/institute-departament.service';

@Component({
	selector: 'app-inspectable-modal',
	templateUrl: './inspectable-modal.component.html',
	styleUrls: ['./inspectable-modal.component.css']
})
export class InspectableModalComponent implements OnInit {
	@Input() checklistInspectables: InstituteDepartamentModel[];
	@Output() onSave = new EventEmitter<InstituteDepartamentModel[]>();
	display: boolean;
	
	institute_departaments: InstituteDepartamentModel[] = [];
	options: TreeNode[] = [];
	selectedOptions: TreeNode[] = [];

	constructor(
		private instituteDepartamentService: InstituteDepartamentService,
		private translateService: TranslateService,
		) { 
	}

	ngOnInit() {
	}

	saveInspectables() {
		let data: InstituteDepartamentModel[] = [];

		this.selectedOptions.forEach(selected => {
			if(selected.parent){
				this.institute_departaments.forEach(item => {
					if(item.institute_id == selected.parent.data && item.departament_id == selected.data) {
						data.push(item);
					}
				});
			}
		});
		this.onSave.emit(data);
		this.display = false;
	}

	onOpenModal() {
		if (!this.options) this.buildOptions();
		if (this.options && this.options.length == 0) this.buildOptions();
		
		// setTimeout(() => {
		// 	this.buildSelectedOptions();
		// }, 100);
	}

	buildSelectedOptions() {		
		let institute_ids: number[] = [];
		let institutes = [];

		this.checklistInspectables.forEach(item => {
			if(!institute_ids.includes(item.institute_id)) {
				institute_ids.push(item.institute_id);
			}
		});

		institute_ids.forEach(id => {
			let departaments: number[] = [];

			this.checklistInspectables.forEach(item => {
				if(item.institute_id == id)	{
					departaments.push(item.departament_id);
				}
			});

			institutes.push({institute_id: id, departaments});
		});

		institutes.forEach(({institute_id, departaments}) => {
			this.options.forEach(item => {
				if(institute_id == item.data) {
					if(item.children && item.children.length > 0) {
						item.children.forEach(subItem => {
							if(departaments.includes(subItem.data)) {
								this.selectedOptions.push(subItem);
							}
						});
					}
					item.partialSelected = (item.children.length > departaments.length) ? true: false;

					if(!item.partialSelected) {
						this.selectedOptions.push(item);
					}
				}
			});
		});		
	}

	buildOptions() {
		this.options = []
		this.instituteDepartamentService.findAllInstitutes().subscribe(
			institutes => {
				institutes.forEach(item => {
					let institute = {
						label: item.name + ' (' + item.city + ')',
						data: item.id,
						expanded: true,
						children: []
					};

					if(item.departaments && item.departaments.length > 0){
						item.departaments.forEach( children => {
							this.institute_departaments.push(children.InstituteDepartamentEntity as InstituteDepartamentModel);

							institute.children.push({
								label: children.name,
								data: children.id
							});
						});
					};					
					this.options.push(institute);
				})
				this.buildSelectedOptions();
				return true;
			}
		);
	}

	translate = (key: string) => this.translateService.instant(key || "invalid");
	tUpper = (key) => this.translate(key).toString().toUpperCase();
	tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);

}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/inspectable-modal/inspectable-modal.component.ts